var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.75 4.5C7.10818 4.5 3.50001 7.82654 3.50001 11.75C3.50001 13.1574 3.9564 14.4748 4.75545 15.5943C4.9005 15.7975 4.93491 16.0596 4.84725 16.2934L3.92603 18.7499L7.34759 18.0656C7.50664 18.0338 7.6717 18.0544 7.81804 18.1244C8.98405 18.6815 10.3226 19 11.75 19C16.3918 19 20 15.6735 20 11.75C20 7.82654 16.3918 4.5 11.75 4.5ZM2.00001 11.75C2.00001 6.8369 6.45072 3 11.75 3C17.0493 3 21.5 6.8369 21.5 11.75C21.5 16.6631 17.0493 20.5 11.75 20.5C10.191 20.5 8.71362 20.1715 7.40196 19.5845L2.8971 20.4854C2.63007 20.5388 2.35507 20.4433 2.17866 20.2359C2.00225 20.0284 1.95215 19.7416 2.04776 19.4867L3.30655 16.1299C2.47835 14.8458 2.00001 13.3496 2.00001 11.75ZM7.00001 11.75C7.00001 11.3358 7.3358 11 7.75001 11H7.76001C8.17423 11 8.51001 11.3358 8.51001 11.75C8.51001 12.1642 8.17423 12.5 7.76001 12.5H7.75001C7.3358 12.5 7.00001 12.1642 7.00001 11.75ZM11 11.75C11 11.3358 11.3358 11 11.75 11H11.76C12.1742 11 12.51 11.3358 12.51 11.75C12.51 12.1642 12.1742 12.5 11.76 12.5H11.75C11.3358 12.5 11 12.1642 11 11.75ZM15 11.75C15 11.3358 15.3358 11 15.75 11H15.76C16.1742 11 16.51 11.3358 16.51 11.75C16.51 12.1642 16.1742 12.5 15.76 12.5H15.75C15.3358 12.5 15 12.1642 15 11.75Z",
    fill: "#D53E20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.65c1d2ac1e735391141b1a5845b9bc7a.svg";
export { ForwardRef as ReactComponent };